import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { RouteReuseStrategy, provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { DepartureValidator, DateValidator, SipsiValidityValidator, PassportValidityValidator, BusinessVisaValidityValidator, WorkVisaValidityValidator, WorkPermitValidityValidator, todayOrLater } from './components/formly/formly-date-selection/date-validator';
import { CoreModule } from './core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { emailValidator, englishCharactersOnlyValidator } from './components/formly/validation-rules';
import { AppRouteReuseStrategy } from './core/route-reuse-strategy';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: RouteReuseStrategy,
      useClass: AppRouteReuseStrategy
    },
    importProvidersFrom(
      CoreModule.forRoot(),
      TranslateModule.forRoot(),
      ReactiveFormsModule,
      FormlyModule.forRoot({
        validators: [
          { name: 'date', validation: DateValidator },
          { name: 'email', validation: emailValidator },
          { name: 'todayOrLater', validation: todayOrLater },
          { name: 'englishCharactersOnly', validation: englishCharactersOnlyValidator },
          { name: 'departureValidator', validation: DepartureValidator },
          { name: 'passportValidityValidator', validation: PassportValidityValidator },
          { name: 'sipsiValidityValidator', validation: SipsiValidityValidator },
          { name: 'businessVisaValidityValidator', validation: BusinessVisaValidityValidator },
          { name: 'workVisaValidityValidator', validation: WorkVisaValidityValidator },
          { name: 'workPermitValidityValidator', validation: WorkPermitValidityValidator },
        ],
        validationMessages: [
          { name: 'email', message: 'Please enter a valid email address' },
          { name: 'required', message: 'This field is required' },
          { name: 'invalidDate', message: 'Invalid date, please use format yyyy-MM-dd' },
          { name: 'todayOrLater', message: 'Invalid date, cannot be earlier than today\'s date' },
          { name: 'invalidDeparture', message: 'Expected departure cannot be before expected arrival' },
          { name: 'invalidIssuedExpiry', message: 'Expiry date cannot be before issued date' },
          { name: 'englishCharactersOnly', message: 'Please use english characters only' },
        ],
      }),
      FormlyBootstrapModule
    ),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
      withRouterConfig({
        paramsInheritanceStrategy: 'always',
        onSameUrlNavigation: 'reload',
      })
    ),
    provideHttpClient(),
  ]
};
